module.exports = __webpack_public_path__ + "static/img/cover.6a8690f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_8/cover.jpg
// module id = tB5V
// module chunks = 0